export const ProjectDocFolderSurveyTypes = {
  Standart: 1,// Не назначено
  EngineeringGeodeticSurveys: 2,// Инженерно-геодезические изыскания
  EngineeringGeologicalSurveys: 3,// Инженерно-геологические изыскания
  EngineeringEnvironmentalSurveys: 4,// Инженерно-экологические изыскания
  STY: 5,// СТУ
  RPR: 6,// РПР
}
